import { memo } from "react";
import { NodeResizer, useStore } from "reactflow";

const eqCounts = (a, b) => a.prdtCount === b.prdtCount && a.colorCount === b.colorCount;

const FrameNode = memo(function FrameNode({ data, selected, width: nodeWidth, height: nodeHeight, id }) {
  const width = data?.width || nodeWidth || 400;
  const height = data?.height || nodeHeight || 300;

  // StyleCard 데이터 변경 포함 모든 변화에 반응하도록 계산 전체를 셀렉터 안에서 수행
  // eqCounts로 실제 값이 바뀔 때만 리렌더
  const { prdtCount, colorCount } = useStore(s => {
    const frameNode = s.getNodes().find(n => n.id === id);
    if (!frameNode) return { prdtCount: 0, colorCount: 0 };

    const fw = frameNode.data?.width || frameNode.width || 400;
    const fh = frameNode.data?.height || frameNode.height || 300;
    const fx1 = frameNode.position.x;
    const fy1 = frameNode.position.y;
    const fx2 = fx1 + fw;
    const fy2 = fy1 + fh;

    let prdtCount = 0;
    let colorCount = 0;

    s.getNodes()
      .filter(n => n.type === 'StyleCard' && n.id !== id)
      .forEach(card => {
        const cx1 = card.position.x;
        const cy1 = card.position.y;
        const cx2 = cx1 + (card.data?.width || card.width || 260);
        const cy2 = cy1 + (card.data?.height || card.height || 260);

        if (cx1 < fx2 && cx2 > fx1 && cy1 < fy2 && cy2 > fy1) {
          const { salesData, colors, color_count, mapType, part_cd } = card.data || {};
          if (!part_cd) return; // 품번 없으면 카운트 제외
          prdtCount++;
          if (mapType === '레인지맵' && color_count) {
            // 레인지맵은 color_count(숫자) 우선 사용
            colorCount += Number(color_count) || 0;
          } else if (Array.isArray(salesData) && salesData.length > 0) {
            colorCount += salesData.length;
          } else if (Array.isArray(colors) && colors.length > 0) {
            colorCount += colors.length;
          } else if (color_count) {
            colorCount += Number(color_count) || 0;
          }
        }
      });

    return { prdtCount, colorCount };
  }, eqCounts);

  return (
    <>
      <div
        id={`node-${id}`}
        style={{ width, height, position: 'relative' }}
        title={prdtCount > 0 || colorCount > 0 ? `STYLE ${prdtCount} / SKU ${colorCount}` : undefined}
      >
        <NodeResizer
          color="#6b7280"
          lineColor="transparent"
          lineStyle={{ stroke: 'transparent', strokeWidth: 0 }}
          handleStyle={{
            backgroundColor: '#ffffff',
            border: '2px solid #6b7280',
            borderRadius: '50%',
            width: 14,
            height: 14,
            boxSizing: 'border-box',
          }}
          isVisible={selected}
          minWidth={80}
          minHeight={60}
        />

        {/* 프레임 테두리 */}
        <div
          style={{
            position: 'absolute',
            inset: 0,
            border: '4px dashed rgb(191 193 197 / 90%)',
            borderRadius: 4,
            pointerEvents: 'none',
            boxSizing: 'border-box',
          }}
        />

        {/* 내부 우측 상단 카운트 */}
        {(prdtCount > 0 || colorCount > 0) && (
          <div
            style={{
              position: 'absolute',
              top: 12,
              right: 12,
              display: 'flex',
              gap: 5,
              pointerEvents: 'none',
              zIndex: 1,
            }}
          >
            <span style={{
              fontSize: 16,
              fontWeight: 700,
              color: '#6b7280',
              background: 'rgba(229,231,235,0.9)',
              borderRadius: 4,
              padding: '5px 10px',
              whiteSpace: 'nowrap',
            }}>
              STYLE {prdtCount}
            </span>
            <span style={{
              fontSize: 16,
              fontWeight: 700,
              color: '#6b7280',
              background: 'rgba(229,231,235,0.9)',
              borderRadius: 4,
              padding: '5px 10px',
              whiteSpace: 'nowrap',
            }}>
              SKU {colorCount}
            </span>
          </div>
        )}

      </div>
    </>
  );
}, (prev, next) => {
  return (
    prev.id === next.id &&
    prev.selected === next.selected &&
    prev.width === next.width &&
    prev.height === next.height &&
    prev.data?.width === next.data?.width &&
    prev.data?.height === next.data?.height &&
    prev.data?.title === next.data?.title
  );
});

export default FrameNode;
